module.exports = __webpack_public_path__ + "img/fila_atendimento.26da71bf.jpg";